class ShopByGoalHexagons extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.shop-by-goal-hexagons__hexagon').forEach((hexagon,index) => {
      hexagon.addEventListener('click', (e) => {
        let element = e.target;
        if (!e.target.classList.contains('shop-by-goal-hexagons__hexagon')) {
          element = e.target.closest('.shop-by-goal-hexagons__hexagon');
        }
        if (!element.classList.contains('active')) {
          
          const activeEl = this.querySelector('.shop-by-goal-hexagons__hexagon.active');
          if (activeEl != element) {
            activeEl.classList.remove('active')
          }
          element.classList.add('active');

          const tabItems = document.querySelectorAll('[data-hexagon-tab]');

          tabItems.forEach((tabItem) => {
            const tabIndex = tabItem.getAttribute('data-hexagon-tab');
            if (tabIndex == index+1) {
              tabItem.style.display = 'block';
            }else{
              tabItem.style.display = 'none';
            }
          })
        }
      });

      if ('#'+hexagon.id == window.location.hash) {
        this.querySelector('.shop-by-goal-hexagons__hexagon.active')?.classList.remove('active');
        hexagon.classList.add('active');
      }
    });

    window.addEventListener('hashchange', ()=>{
      this.querySelectorAll('.shop-by-goal-hexagons__hexagon').forEach((hexagon,index) => {
        if ('#'+hexagon.id == window.location.hash) {
          this.querySelector('.shop-by-goal-hexagons__hexagon.active')?.classList.remove('active');
          hexagon.classList.add('active');
          hexagon.scrollIntoView({block:'center'});
          setTimeout(() => {
            hexagon.scrollIntoView({block:'center'});
          }, 500);
        }
      });
    });
  }

}

customElements.define('shop-by-goal-hexagons', ShopByGoalHexagons);
